import {useState} from "react";
import {Col} from "react-bootstrap";
import ActiveWorkerToggleGroup from "../ActiveWorkerToggleGroup";

export default function SchedulerWorkerLane({
    activeWorkerId,
    boardHeight,
    children,
    fieldWorkerArray,
    fieldWorkerMap,
    onActiveWorkerChange,
    onDropJob,
    workerWorkloadCounts,
}) {
    const [isHighlighted, setIsHighlighted] = useState(false);

    return (
        <Col
            className="scheduler-worker-lane"
            onDragOver={(event) => {
                event.preventDefault();
                setIsHighlighted(true);
            }}
            onDragLeave={() => setIsHighlighted(false)}
            onDrop={(event) => {
                event.preventDefault();
                setIsHighlighted(false);
                onDropJob(event);
            }}
            style={{
                height: boardHeight,
                border: isHighlighted ? "3px dashed darkBlue" : "3px dashed transparent",
            }}
        >
            <ActiveWorkerToggleGroup
                activeWorkerId={activeWorkerId}
                setActiveWorkerId={onActiveWorkerChange}
                workerWorkloadCounts={workerWorkloadCounts}
                fieldWorkerMap={fieldWorkerMap}
                fieldWorkerArray={fieldWorkerArray}
            />
            {children}
        </Col>
    );
}
